<template>
    <div>
        <div class="page-filter-box">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-input v-model="params.searchValue" class="input-with-select" size="small">
                        <el-select v-model="params.searchType" slot="prepend" placeholder="请选择">
                            <el-option label="活动ID" :value="1"></el-option>
                            <el-option label="活动名称" :value="2"></el-option>
                        </el-select>
                    </el-input>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.status" placeholder="请选择" size="small">
                        <el-option label="不限制活动状态" value=""></el-option>
                        <el-option label="仅看未开启的" :value="1"></el-option>
                        <el-option label="仅看进行中的" :value="2"></el-option>
                        <el-option label="仅看已结束的" :value="3"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4" class="page-filter-btns">
                    <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                    <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
                </el-col>
            </el-row>
        </div>
        <div class="page-btns-box">
            <el-button v-if="$utils.have('/expand/save')" type="primary" icon="el-icon-plus" size="small" @click="add()">创建活动</el-button>
        </div>
        <div class="page-list-box">
            <el-table
                :data="dataList"
                border
                style="width: 100%"
                v-loading="listLoading"
                size="small"
                stripe
            >
                <el-table-column prop="id" label="活动ID"></el-table-column>
                <el-table-column prop="name" label="活动名称" min-width="200" show-overflow-tooltip></el-table-column>
				<el-table-column prop="statusName" label="状态"></el-table-column>
                <el-table-column label="活动起止时间" :min-width="180">
                    <template slot-scope="scope">
                        <p>起：{{`${scope.row.startTime}`}}</p>
                        <p>止：{{`${scope.row.endTime}`}}</p>
                    </template>
                </el-table-column>
				<el-table-column label="活动展示时间" :min-width="180">
				    <template slot-scope="scope">
				        <p>上线：{{`${scope.row.onTime}`}}</p>
				        <p>下线：{{`${scope.row.offTime}`}}</p>
				    </template>
				</el-table-column>
				<el-table-column prop="totalUser" label="用户总数" min-width="110"></el-table-column>
				<el-table-column label="UV">
				    <template slot-scope="scope">
				        <p>秀动：<span>{{`${scope.row.totalUv}`}}</span></p>
				        <p>百度：<span>{{`${scope.row.totalBdUv}`}}</span></p>
				    </template>
				</el-table-column>
				<el-table-column label="PV">
				    <template slot-scope="scope">
				        <p>秀动：<span>{{`${scope.row.totalPv}`}}</span></p>
				        <p>百度：<span>{{`${scope.row.totalBdPv}`}}</span></p>
				    </template>
				</el-table-column>
				<el-table-column label="注册转化" :min-width="180">
				    <template slot-scope="scope">
				        <p>注册人数：{{`${scope.row.totalRegisterCount}`}}</p>
				        <p>转化率：{{`${scope.row.userCr}`}}</p>
				    </template>
				</el-table-column>
				<el-table-column label="订单转化" :min-width="180">
				    <template slot-scope="scope">
				        <p>下单人数：{{`${scope.row.totalOrderUserCount}`}}</p>
				        <p>转化率：{{`${scope.row.orderCr}`}}</p>
				    </template>
				</el-table-column>
				<el-table-column label="订单">
				    <template slot-scope="scope">
				        <p>订单数：{{`${scope.row.totalOrderCount}`}}</p>
				        <p>销售额：{{`${scope.row.totalSaleAmount}`}}</p>
				    </template>
				</el-table-column>
                <el-table-column prop="launchUserNum" label="发起活动用户数" min-width="110"></el-table-column>
                <el-table-column prop="joinUserNum" label="参与活动用户数" min-width="110"></el-table-column>
                <el-table-column prop="newUserNum" label="活动新注册用户数" min-width="120"></el-table-column>
                <el-table-column fixed="right" label="操作" width="230">
                    <template slot-scope="scope">
                        <el-button v-if="$utils.have('/expand/save')" type="text" size="small" @click="edit(scope.row.id)" >编辑</el-button>
						<el-button type="text" size="small" @click="copy(scope.row.wapLink)">活动链接</el-button>
                        <el-button v-if="$utils.have('/expand/userPortrait')" type="text" size="small" @click="dashboard(scope.row.id)" >活动数据</el-button>                        
						<el-button v-if="$utils.have('/expand/userList')" type="text" size="small" @click="userlist(scope.row.id)" >用户列表</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="getDataList"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="data.totalCount || 0">
            </el-pagination>
        </div>
        <Statistics ref="statistics"></Statistics>
        <input class="copyTool" ref="copyTool" :value="copyUrl" />
    </div>
</template>

<script>
import Statistics from "./components/statistics";
const defaultParams = {
    pageNo: 1,
    searchType: 1,
    searchValue: "",
    status: ""
}
export default {
    components:{Statistics},
    data(){
        return{
            data: null,
            dataList: null,
            params:{
                ...defaultParams,
                pageNo: parseInt(this.$route.query.pageNo || 1),
                pageSize: parseInt(this.$route.query.pageSize || this.$pageSizes[0]),
                searchType: parseInt(this.$route.query.searchType || 1),
                searchValue: this.$route.query.searchValue || "",
                status: parseInt(this.$route.query.status) || "",
            },
            listLoading: true,
            sswap:process.env.VUE_APP_SSWAP_URL,
            copyUrl: "",
            copyTimer: null
        }
    },
    mounted() {
        this.getDataList();
    },
    methods: {
        //获取列表
        getDataList() {
            this.listLoading = true;
            this.$request({
                url: "/expand/list",
                method: "POST",
                data: {
                    ...this.params
                },
            })
			.then((res) => {
				const { state, msg, result } = res.data;
				if ( state == 1 && result) {
					this.data = result;
					this.dataList = result.result || [];
                    this.dataList.map(item => {
                        item.wapLink = `${this.sswap}/pages/special/expand/index?id=${item.id}`
                    })
				} else {
					this.$message.error(msg || "请求失败");
				}
			})
			.catch(() => {
				this.$message.error("请求错误");
			})
			.finally(() => {
				this.listLoading = false;
			});
        },
        //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        //重置搜索
        reset() {
            this.params = {
                ...defaultParams,
                pageSize: this.params.pageSize,
            };
            this.getDataList();
        },
        //查看活动数据
        statistics(id){
            this.$refs.statistics.show(id);
        },
        //复制链接
        copy(url){
            clearTimeout(this.copyTimer);
            this.copyUrl = url;
            this.copyTimer = setTimeout(() => {
                const e = this.$refs.copyTool;
                e.select();
                document.execCommand("Copy"); // 执行浏览器复制命令
                this.$message.success("已复制成功，可粘贴");
            },300)
        },
        add(){
            this.$router.push('/promotion/expand/add')
        },
		userlist(id){
			this.$router.push({
			    path: `/promotion/expand/userList/${id}`,
			    query: {
			        redirect: this.$utils.objArgs(
			            this.$router.currentRoute.path,
			            this.params
			        ),
			    },
			});
		},
		dashboard(id){
			this.$router.push({
			    path: `/promotion/expand/dashboard/${id}`,
			    query: {
			        redirect: this.$utils.objArgs(
			            this.$router.currentRoute.path,
			            this.params
			        ),
			    },
			});
		},
        edit(id){
            this.$router.push({
                path: `/promotion/expand/edit/${id}`,
                query: {
                    redirect: this.$utils.objArgs(
                        this.$router.currentRoute.path,
                        this.params
                    ),
                },
            });
        }
    }
}
</script>

<style lang="scss" scoped>
.copyTool{
    opacity: 0;
    filter: alpha(opacity=0);
    // height: 1px;
}
</style>